const PinIconSvg = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <g clipPath="url(#clip0_10539_97680)">
        <path
          d="M8 9C9.10457 9 10 8.10457 10 7C10 5.89543 9.10457 5 8 5C6.89543 5 6 5.89543 6 7C6 8.10457 6.89543 9 8 9Z"
          fill="#3B3F42"
        />
        <path
          d="M7.3 15.7C7.2 15.6 3.1 12 3.1 11.9C1.7 10.7 1 8.9 1 7C1 3.1 4.1 0 8 0C11.9 0 15 3.1 15 7C15 8.9 14.3 10.7 12.9 12C12.8 12.1 8.8 15.7 8.7 15.8C8.3 16.1 7.7 16.1 7.3 15.7ZM4.6 10.7L8 13.7L11.4 10.7C12.4 9.7 13 8.5 13 7.1C13 4.3 10.8 2.1 8 2.1C5.2 2.1 3 4.2 3 7C3 8.4 3.6 9.7 4.6 10.7C4.6 10.6 4.6 10.6 4.6 10.7Z"
          fill="#3B3F42"
        />
      </g>
    </svg>
  );
};

export default PinIconSvg;
